import { render, staticRenderFns } from "./SceneSelection.vue?vue&type=template&id=21b13e1c&scoped=true"
import script from "./SceneSelection.vue?vue&type=script&lang=js"
export * from "./SceneSelection.vue?vue&type=script&lang=js"
import style0 from "./SceneSelection.vue?vue&type=style&index=0&id=21b13e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b13e1c",
  null
  
)

export default component.exports